import CalculateIcon from '@mui/icons-material/Calculate';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import ThermostatIcon from '@mui/icons-material/Thermostat';
export const headerData = [
    {
        icon: <SignalCellularAltIcon sx={{ fontSize: 24 }} />,
        title: 'Objetivo',
        text: 'Observar la ***evolución de tus cultivos***, siguiendo su desarrollo desde la emergencia hasta la cosecha junto a los estadios con la acumulación de GDUs reales.',
    },
    {
        icon: <NotificationsActiveIcon sx={{ fontSize: 24 }} />,
        title: 'Alertas',
        text: 'Identificar momentos específicos dentro del ciclo para la aplicación de productos químicos, ya sea para el control de malezas, plagas o enfermedades.',
    },
    {
        icon: <ThermostatIcon sx={{ fontSize: 24 }} />,
        title: 'Factores Climáticos',
        text: 'Podrás seguir el estado de las condiciones meteorológico a la fecha y también el pronóstico, visualizando cómo puede afectar el rendimiento general de tus cultivos.',
    },
    {
        icon: <CalculateIcon sx={{ fontSize: 24 }} />,
        title: 'Y mucho más...',
        text: 'Podrás acceder a otras opciones, como por ejemplo ***recomendaciones de aplicaciones de productos fitosanitarios en el momento adecuado***.',
    },
];
